/* eslint-disable no-restricted-syntax */
import lod_ from "lodash";
import { getInterval } from "../DatePresets";

/**
 * Encode a local date as UTC (local wall clock kept, e.g. 00:00 Paris -> 00:00Z)
 * Used by the date filter to store dates
 */
export const toUTC = date => {
	if (!date) return null;
	const d = new Date(date);
	return new Date(d.getTime() - d.getTimezoneOffset() * 60000);
};

/**
 * Decode a date encoded with toUTC back to a local date
 */
export const fromUTC = dateOrString => {
	if (!dateOrString) return null;
	const d = new Date(dateOrString);
	return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
};

/**
 * Get filters from local storage for the front menus
 */
export function getLocalStorageFrontValues(assistantID, page, attribute, filters) {
	// Get filters for assistant
	let actualFilters = filters[assistantID];
	if (!actualFilters) return null;
	// Get filters for assistant > page
	actualFilters = actualFilters[page];
	if (!actualFilters) return null;
	// Get filters for assistant > page > attribute
	let actualFilter = actualFilters[attribute];
	if (!actualFilter) return null;
	// Return front value
	switch (actualFilter.type) {
		case "datetime": {
			// Mode auto = recompute interval
			if (actualFilter.mode === "auto" && actualFilter.code) {
				let interval = getInterval(actualFilter.code);
				// Encode like stored manual dates, the date filter decodes them with fromUTC
				return lod_.mapValues(interval, toUTC);
			} else {
				return actualFilter.values;
			}
		}
		default:
			return actualFilter.front;
	}
}
/**
 * Get filters from local storage for the back requests
 */
export function getLocalStorageBackValues(assistantID, page, filters) {
	// Get filters for assistant
	let actualFilters = filters[assistantID];
	if (!actualFilters) return {};
	// Get filters for assistant > page
	actualFilters = actualFilters[page];
	if (!actualFilters) return {};
	// Map filters
	let keys = Object.keys(actualFilters);
	let backFilters = {};
	for (let key of keys) {
		switch (actualFilters[key].type) {
			case "datetime": {
				let filter = actualFilters[key];
				// Mode auto = recompute interval
				if (filter.mode === "auto" && filter.code) {
					let interval = getInterval(filter.code);
					backFilters[key] = { name: filter.attribute, type: filter.type, value: interval };
				} else {
					backFilters[key] = { name: filter.attribute, type: filter.type, value: filter.values };
				}
				break;
			}
			default:
				backFilters[key] = actualFilters[key].back;
				break;
		}
	}
	return backFilters;
}

/**
 * Dates as displayed by the page date filters (what the date picker shows, decoded with fromUTC),
 * by attribute: { [attribute]: { $gte, $lte } } as ISO strings
 * The back values can't be displayed directly: manual dates are stored encoded with toUTC
 */
export function getLocalStorageDisplayDates(assistantID, page, filters) {
	const pageFilters = filters?.[assistantID]?.[page] ?? {};
	const dates = {};
	for (const attribute of Object.keys(pageFilters)) {
		if (pageFilters[attribute]?.type !== "datetime") continue;
		const values = getLocalStorageFrontValues(assistantID, page, attribute, filters);
		if (!values) continue;
		dates[attribute] = lod_.omitBy(
			lod_.mapValues(values, value => {
				const date = fromUTC(value);
				return date && !Number.isNaN(date.getTime()) ? date.toISOString() : null;
			}),
			lod_.isNil
		);
	}
	return dates;
}
